import { render, staticRenderFns } from "./Dispositions.vue?vue&type=template&id=cabbd40a&scoped=true&"
import script from "./Dispositions.vue?vue&type=script&lang=js&"
export * from "./Dispositions.vue?vue&type=script&lang=js&"
import style0 from "./Dispositions.vue?vue&type=style&index=0&id=cabbd40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbd40a",
  null
  
)

export default component.exports